import {
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Richtext,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { NavigationServiceV1 } from '@volkswagen-onehub/navigation-service';
import React from 'react';

type SfClosedMessageProps = {
	closedHeader: string;
	closedMsg: string;
	navigationService: NavigationServiceV1;
};

export const SfClosedMessage = ({
	closedHeader,
	closedMsg,
	navigationService,
}: SfClosedMessageProps): JSX.Element => {
	const navigateToOtherChannels = (
		event: React.MouseEvent<HTMLButtonElement>,
	) => {
		const target = navigationService.navigateTo('atencion-cliente', {});
		if (target) {
			target.push();
		} else {
			console.error('Not atencion-cliente pageId created');
		}
	};

	return (
		<Container
			padding={{
				top: ContainerPadding.dynamic0100,
				right: ContainerPadding.dynamic0270,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0270,
			}}
			wrap="always"
			gutter={ContainerGutter.dynamic0100}
		>
			<Text appearance={TokenTextAppearance.headline600}>
				{closedHeader}
			</Text>
			<Richtext markdown={closedMsg} />
			<CTA
				tag="button"
				emphasis="tertiary"
				onClick={navigateToOtherChannels}
			>
				Otras maneras de contactar con nosotros
			</CTA>
		</Container>
	);
};
